export const SET_TOAST_STATE = 'set_toast_state';
export const REMOVE_TOAST = 'set_toast';

// GLOBAL LVL FORM
export const SET_PORTAL_ACTIVE_TAB_SWITCHED = 'set-portal-active-tab-switched';
export const SET_SAVE_UI_STATE = 'set_save_ui_state';
export const SET_DISCARD_UI_STATE = 'set_discard_ui_state';
export const TOGGLE_FORM_HANDLER_PORTAL = 'toggle_form_handler_portal';
export const TOGGLE_UNSAVED_PORTAL = 'toggle_unsaved_portal';
